<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }, { rtl: $route.meta.rtlActive }]">
    <notifications></notifications>
    <side-bar :active-color="sidebarBackground" :background-image="sidebarBackgroundImage" :data-background-color="sidebarBackgroundColor">
      <hotel-selection></hotel-selection>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item :link="{ name: 'General', icon: 'apartment' }">
          <sidebar-item :link="{ name: 'Hotel', path: 'hotel' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Room Types', path: 'room-types' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Boards', path: 'boards' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Segments', path: 'segments' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Export / Import', path: 'export-import' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Mail Setup', path: 'mail-setup' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Email Template', path: 'email-template' }"></sidebar-item>
          <!--sidebar-item
            :link="{
              name: 'Channel Integration',
              path: 'channel-integration'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Emails Templates',
              path: 'email-templates'
            }"
          ></sidebar-item-->
        </sidebar-item>
        <sidebar-item :link="{ name: 'Anual Settings', icon: 'event' }">
          <sidebar-item :link="{ name: 'Year Seasons', path: 'year-seasons' }"></sidebar-item>
          <!--<sidebar-item
            :link="{ name: 'Target', path: 'target' }"
          ></sidebar-item>-->
          <sidebar-item :link="{ name: 'Pricing', path: 'pricing' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Services', path: 'services' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Agencies', icon: 'tour', path: 'agencies' }"></sidebar-item>
        <sidebar-item v-if="checkRoleAddminAccess()" :link="{ name: 'Admin Tools', icon: 'admin_panel_settings' }">
          <sidebar-item :link="{ name: 'Reload', path: 'reload' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Invalidate Actions', path: 'invalidate-action' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Forwards Actions', path: 'forwards-action' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Metabase', path: 'metabase' }"></sidebar-item>
        </sidebar-item>
        <!--
        <sidebar-item
          :link="{
            name: 'Alerts',
            icon: 'notifications',
            path: 'alerts'
          }"
        ></sidebar-item> 
        -->
        <sidebar-item
          :link="{
            name: 'Back to home',
            icon: 'keyboard_backspace',
            path: '/pricing',
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar class="md-theme-configuration" prefix="Settings - ">
        <template v-slot:content-end>
          <md-button
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
          <div class="md-collapse">
            <md-list>
              <md-list-item :to="{ path: '/pricing' }">
                <i class="material-icons">keyboard_backspace</i>
                <p class="hidden-lg hidden-md">Salir</p>
              </md-list-item>
            </md-list>
          </div>
        </template>
      </top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="300" mode="out-in" v-if="this.$root.hotelId">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="false && !$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
    document.getElementsByClassName(className)[0].scrollTop = 0
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList
  let isWindows = navigator.platform.startsWith('Win')
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar')
    initScrollbar('sidebar-wrapper')
    initScrollbar('main-panel')

    docClasses.add('perfect-scrollbar-on')
  } else {
    docClasses.add('perfect-scrollbar-off')
  }
}

import { ZoomCenterTransition } from 'vue2-transitions'
import ContentFooter from './ContentFooter.vue'
import HotelSelection from './Extra/HotelSelection.vue'
import MobileMenu from './Extra/MobileMenu.vue'
import TopNavbar from './TopNavbar.vue'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    ZoomCenterTransition,
    HotelSelection,
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'purple',
      sidebarBackgroundImage: './img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    checkRoleAddminAccess() {
      return this.$root.hasBackendRole('admin')
    },
  },
  updated() {
    //reinitScrollbar();
  },
  mounted() {
    //reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    },
  },
}
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>

<style lang="scss" scoped>
.md-toolbar.md-primary {
  background-color: black !important;

  h3.md-title {
    color: white !important;
  }
}
</style>
